import { images } from "../../../Assets/assetsHelper";
import AddCourseForm from "../../../Components/Organisms/Forms/AddCourseForm/AddCourseForm";
import "./AddSession.css";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import AddSessionForm from "../../../Components/Organisms/Forms/AddSessionForm/AddSessionForm";

function AddSession({
  Edit = false,
  Class = null,
  loading = false,
  url,
  session = null,
}) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <MenuBookIcon />
            </div>
            <div className="titleContent">
              <h1>{Edit ? "Edit Session Information" : "Add New Session"}</h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {loading || (Edit && session == null) ? (
              <div className="loadingBox">
                <CircularProgress />
              </div>
            ) : (
              <AddSessionForm
                Edit={Edit}
                Class={Class}
                url={url}
                session={session}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the program profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddSession;
